import { Badge, BadgeColorVariant, BadgeVariant } from "@/components/ui/badge";
import { BadgeList, type BadgeListItem } from "@/components/ui/badge-list";
import { ChevronUp } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface ExpandableBadgeListProps {
  items: BadgeListItem[];
  defaultVisible?: number;
}

export function ExpandableBadgeList({ items, defaultVisible = 2 }: ExpandableBadgeListProps) {
  const { t } = useTranslation("common");
  const [isExpanded, setIsExpanded] = useState(false);

  const hiddenCount = items.length - defaultVisible;
  const hasHidden = hiddenCount > 0;
  const displayedItems = isExpanded ? items : items.slice(0, defaultVisible);

  const handleExpand = (e: React.MouseEvent): void => {
    e.stopPropagation();
    setIsExpanded(true);
  };

  const handleCollapse = (e: React.MouseEvent): void => {
    e.stopPropagation();
    setIsExpanded(false);
  };

  return (
    <div className="flex flex-col gap-1">
      <BadgeList items={displayedItems} />
      {!isExpanded && hasHidden && (
        <Badge
          variant={BadgeVariant.Filled}
          colorVariant={BadgeColorVariant.Secondary}
          className="w-fit cursor-pointer"
          onClick={handleExpand}
        >
          +{hiddenCount} {t("More")}
        </Badge>
      )}
      {isExpanded && hasHidden && (
        <Badge
          variant={BadgeVariant.Filled}
          colorVariant={BadgeColorVariant.Secondary}
          className="w-fit cursor-pointer"
          onClick={handleCollapse}
        >
          <ChevronUp className="mr-1 h-3 w-3" />
          {t("Collapse")}
        </Badge>
      )}
    </div>
  );
}
